import client from '../../client'
import { ApiResponse } from '../../types'
import { ActivityId } from '../activities'
import {
  GetActivityFacilityRankingResponse,
  ListActivityRankingsResponse,
  GetUserRankingResponse,
} from './types'

export * from './types'

export const listActivityRankings = async () => {
  const { data }: ApiResponse<ListActivityRankingsResponse> = await client.get(
    `/user/ranking/activities`
  )

  return data
}

export const getActivityFacilityRanking = async (activityId: ActivityId) => {
  const { data }: ApiResponse<GetActivityFacilityRankingResponse> =
    await client.get(`/user/ranking/facilitiesByActivity/${activityId}`)

  return data
}

export const getUserRanking = async (targetMonth?: string) => {
  const { data }: ApiResponse<GetUserRankingResponse> = await client.get(
    `/user/ranking/users${targetMonth ? `/${targetMonth}` : ''}`
  )

  return data
}
